module.exports = "pegasus/assets/lp/ebook/bg2.png";